$shm_tests_visual $mol_view
	comparison null
	manifest_uri \
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_text
					text <= comparison_title \
				<= Status $mol_text
					text <= comparison_status \
		<= Metrics $mol_text
			text <= comparison_metrics \
		<= Images $mol_view
			sub <= image_rows /$mol_view
	Image* $mol_link
		uri <= image_uri* \
		external true
		sub /
			<= Image_label* $mol_text
				text <= image_title* \
			<= Picture* $mol_image
				uri <= image_uri* \
				title <= image_title* \
